import { WebRTCNotificationSection } from './WebRTCNotificationSection';

export * from './WebRTCNotificationSection.interface';
export default WebRTCNotificationSection;
